import CreateWalletConsent from "../auth/CreateWalletConsent";

const OptionsCreateWalletConsent = () => {
  return <CreateWalletConsent isFromOptions />;
};

export default OptionsCreateWalletConsent;
